module.exports = __webpack_public_path__ + "img/reviews-section-bg.378c1209.webp";